/**
 * Created by fengc on 2020/04/02.
 * NOTE:: DO not add float style to sentence! it will break center style
 */
import React from "react";
import * as Helper from "../../utils/Helper";
import PropTypes from "prop-types";
import Word from "./Word";
import { GetSentenceStyleBySentenceCommand, EnumHasFlag, ParseSetting } from "../../utils/MarkTextHelper";
import Constants from "../../config/Constants";
import _ from "lodash";
import "../../assets/scss/components/ui/sentence.scss";

class Sentence extends React.Component {
    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.charVisible !== nextProps.charVisible) {
            return true;
        }
        if (this.props.pinyinVisible !== nextProps.pinyinVisible) {
            return true;
        }
        if (this.props.onWordClick !== nextProps.onWordClick) {
            return true;
        }
        if (this.props.onLetterClick !== nextProps.onLetterClick) {
            return true;
        }
        if (this.props.onSyllableChange !== nextProps.onSyllableChange) {
            return true;
        }
        if (!_.isEqual(this.props.style, nextProps.style)) {
            return true;
        }
        if (!_.isEqual(this.props.wordStyle, nextProps.wordStyle)) {
            return true;
        }
        if (!_.isEqual(this.props.letterStyle, nextProps.letterStyle)) {
            return true;
        }
        if (!_.isEqual(this.props.overriddenWords, nextProps.overriddenWords)) {
            return true;
        }
        if (!_.isEqual(this.props.data, nextProps.data)) {
            return true;
        }
        return false;
    }

	render() {
		let wordStyle = { ...this.props.wordStyle };

		for (var key in this.props.style) {
			if (!(key === "color" || key.indexOf("font") !== -1)) continue;

			// if this "font" property is undefined in wordStyle, it will be added to wordStyle!
			if (!wordStyle[key]) {
				wordStyle[key] = this.props.style[key];
			}
		}

		let containerStyle = styles.container;
		if (this.props.style) {
			containerStyle = { ...containerStyle, ...this.props.style };
		}

		const { sentenceCommand, sentenceCommandSetting } = this.props.data;
		const sentenceStyle = GetSentenceStyleBySentenceCommand(sentenceCommand, sentenceCommandSetting);

		if (_.isNumber(sentenceCommand)) {
			if (EnumHasFlag(sentenceCommand, Constants.SENTENCE_MARK_TYPE.DIALOG)) {
				const parsedSetting = ParseSetting(sentenceCommandSetting);
				if (parsedSetting && parsedSetting.role) {
					if (_.toLower(parsedSetting.role) === "a") {
						return this._renderDialog("a", sentenceStyle, containerStyle, wordStyle);
					} else if (_.toLower(parsedSetting.role) === "b") {
						return this._renderDialog("b", sentenceStyle, containerStyle, wordStyle);
					}
				}
			}
		}

		return this._renderContent(sentenceStyle, containerStyle, wordStyle);
	}

	_renderContent = (sentenceStyle, containerStyle, wordStyle) => {
		const { words, sentenceIndex } = this.props.data;
		//some style need use a class, for now its indent
		const className = sentenceStyle.sentenceClassName;
		return (
			<div style={{ ...sentenceStyle, ...containerStyle }} className={className}>
				{words &&
					words.map((item, i) => {
						if (this.props.overriddenWords && this.props.overriddenWords.words && this.props.overriddenWords.renderOverriddenWord) {
							for (let j = 0; j < this.props.overriddenWords.words.length; j++) {
								var word = this.props.overriddenWords.words[j];
								if (Helper.isTwoWordsSame(word, item)) {
									// The event here cannot be registered automatically.
									// Please register the corresponding event manually in the render method
									return this.props.overriddenWords.renderOverriddenWord(item, i);
								}
							}
						}
						item.sentenceIndex = sentenceIndex;
						item.wordIndex = i;

						return (
							<Word
								key={i}
								data={item}
								style={wordStyle}
								letterStyle={this.props.letterStyle}
								onClick={this.props.onWordClick}
								onLetterClick={this.props.onLetterClick}
								onSyllableChange={this.props.onSyllableChange}
								charVisible={this.props.charVisible}
								pinyinVisible={this.props.pinyinVisible}
								overriddenLetters={this.props.overriddenLetters}
							/>
						);
					})}
			</div>
		);
	}

	_renderDialog = (role, sentenceStyle, containerStyle, wordStyle) => {
		return (
			<div style={{display: "flex", flexDirection: (role === "a" ? "row" : "row-reverse"), justifyContent: "flex-start", alignItems: "center", margin: "20px 0px"}}>
				<div style={{...(role === "a" ? {marginRight: "10px"} : {marginLeft: "10px"}), flex: 1, alignSelf:"flex-start"}}>
					<div className="avatar avatar-sm rounded-circle" style={{...styles.avatarStyle, ...wordStyle}}>{_.toUpper(role)}</div>
				</div>
				<div style={{flex: 8, display: "flex", justifyContent: (role === "a" ? "flex-start" : "flex-end")}}>
					{this._renderContent(sentenceStyle, containerStyle, wordStyle)}
				</div>
				<div style={{flex: 1}}></div>
			</div>
		);
	}
}

const styles = {
	container: {
		display: "flex",
		flexDirection: "row",
	},
	avatarStyle: {
        backgroundColor: "#f2f2f2",
        color: "#333"
	},
};

Sentence.propTypes = {
	data: PropTypes.object,
	onWordClick: PropTypes.func,
	onLetterClick: PropTypes.func,
	onSyllableChange: PropTypes.func,
	style: PropTypes.object,
	wordStyle: PropTypes.object,
	letterStyle: PropTypes.object,
	charVisible: PropTypes.bool,
	pinyinVisible: PropTypes.bool,
	overriddenWords: PropTypes.object,
	renderOverriddenWord: PropTypes.func,
	overriddenLetters: PropTypes.object,
	renderOverriddenLetter: PropTypes.func,
};

Sentence.defaultProps = {
	data: { words: [] },
	style: {}, // custom container style
	wordStyle: {},
	letterStyle: {},
	onWordClick: null,
	onLetterClick: null,
	onSyllableChange: null,
	charVisible: true, // if show Chinese character
	pinyinVisible: true, // if show piyin of chinese character
	overriddenWords: { words: [], renderOverriddenWord: null }, // customize words' display and control
	overriddenLetters: { letters: [], renderOverriddenLetter: null }, // customize letters' display and control
};

export default Sentence;
